import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getMemberNotificationSettingsKey, getPostsKey, getSpaceKey, getSpacesKey, } from '../../utils/keys';
export const useLeaveSpace = (options) => {
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    return useMutation((input) => client.spaces.leave(input), {
        onSettled: (data, error, variables) => {
            queryClient.invalidateQueries(getSpaceKey({ variables: { id: variables.spaceId } }));
            queryClient.invalidateQueries(getMemberNotificationSettingsKey());
            queryClient.invalidateQueries(getPostsKey());
            queryClient.invalidateQueries(getSpacesKey());
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useLeaveSpace.js.map